"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.marketDefault = exports.GLOBAL_MARKET_ID = void 0;
const GLOBAL_MARKET_ID = exports.GLOBAL_MARKET_ID = "xx";
const marketDefault = exports.marketDefault = {
  id: GLOBAL_MARKET_ID,
  name: "Global",
  flag: "",
  languages: [{
    id: "en",
    name: "English"
  }, {
    id: "es",
    name: "Español"
  }, {
    id: "vn",
    name: "Tiếng Việt"
  }, {
    id: "my",
    name: "Bahasa Melayu"
  }, {
    id: "id",
    name: "Bahasa Indonesia"
  }, {
    id: "tw",
    name: "台灣話"
  }, {
    id: "ar",
    name: "العربية/عربي (Saudi Arabia)"
  }, {
    id: "fr",
    name: "Français"
  }, {
    id: "ru",
    name: "Русский"
  }],
  defaultLanguage: "en"
};